import { BrainMapsDashboard } from "./brain-maps/BrainMapsDashboard";
import { ClientConversionDashboard } from "./client-conversion-rate/ClientConversionDashboard";
import { DailyAnalysisDashboard } from "./daily-analysis/DailyAnalysisDashboard";
import { DigitalMarketingDashboard } from "./digital-marketing/DigitalMarketingDashboard";
import { FinanceDashboard } from "./finance/FinanceDashboard";
import { PricesDashboard } from "./prices/PricesDashboard";
import { ReceptionKpisDashboard } from "./reception-kpis/ReceptionKpisDashboard";
import { SessionsTreatmentsDashboard } from "./sessions-treatments/SessionsTreatmentsDashboard";
import { TeamKpisDashboard } from "./clinic-service-team-kpis/TeamKpisDashboard";
import { TeamTasksDashboard } from "./team-tasks-productivity/TeamTasksDashboard";
import { NeurofeedbackProductivityDashboard } from "./neurofeedback-productivity/NeurofeedbackProductivityDashboard";
import { QeegPendingReportsDashboard } from "./qeeg-pending-reports/QeegPendingReportsDashboard";

export const nativeDashboardRegistry: Record<string, () => JSX.Element> = {
    "daily-analysis": DailyAnalysisDashboard,
    "sessions-treatments": SessionsTreatmentsDashboard,
    "reception-kpis": ReceptionKpisDashboard,
    prices: PricesDashboard,
    "digital-marketing": DigitalMarketingDashboard,
    finance: FinanceDashboard,
    "clinic-service-team-kpis": TeamKpisDashboard,
    "team-tasks-productivity": TeamTasksDashboard,
    "neurofeedback-productivity": NeurofeedbackProductivityDashboard,
    "qeeg-pending-reports": QeegPendingReportsDashboard,
    "client-conversion-rate": ClientConversionDashboard,
    "brain-maps": BrainMapsDashboard,
};

export const nativeDashboardRegistryKeys = Object.keys(nativeDashboardRegistry);
